import React from 'react';

import MarvelLink from '@marvelapp/marvel-ui/link';
import Page from 'marketing-website/components/modules/Page';
import assets from 'marketing-website/configs/pages/marvel-vs-invision/assets';
import metaData from 'marketing-website/data/metadata.js';
import ImageBlock from 'marketing-website/components/modules/ImageBlock';
import Experience from 'marketing-website/components/modules/CompetitorAlternatives/Experience.js';
import Header from 'marketing-website/components/modules/CompetitorAlternatives/Header.js';
import Logos from 'marketing-website/components/modules/CompetitorAlternatives/Logos.js';
import Security from 'marketing-website/components/modules/CompetitorAlternatives/Security.js';
import RequestDemo from 'marketing-website/components/modules/CompetitorAlternatives/RequestDemo.js';

import invisionExperienceConfig from '../../components/modules/CompetitorAlternatives/invisionExperienceConfig.js';

const facebookMeta = [
  {
    name: 'og:title',
    content: 'Searching for an InVision alternative?',
  },
  {
    name: 'og:site_name',
    content: 'Marvel vs InVision',
  },
  {
    name: 'og:type',
    content: 'website',
  },
  {
    name: 'og:url',
    content: 'https://marvelapp.com/marvel-vs-invision',
  },
  {
    name: 'og:description',
    content: `Join thousands of teams that have switched to Marvel from
      InVision. We're a simple, yet powerful design platform used by
      over 2 million people to get important work done, faster.`,
  },
  {
    name: 'og:image',
    content: `https://marvelapp.com${assets.sharePreview.src}`,
  },
  {
    name: 'og:site_name',
    content: 'Marvel vs InVision',
  },
];

const twitterMeta = [
  {
    name: 'twitter:site',
    content: 'https://marvelapp.com/marvel-vs-invision',
  },
  {
    name: 'twitter:creator',
    content: 'Marvel vs InVision',
  },
  {
    name: 'twitter:title',
    content: 'Searching for an InVision alternative?',
  },
  {
    name: 'twitter:image',
    content: `https://marvelapp.com${assets.sharePreview.src}`,
  },
];

const meta = {
  title: metaData['marvel-vs-invision'].title,
  meta: [
    {
      name: 'description',
      content: metaData['marvel-vs-invision'].description,
    },
    ...twitterMeta,
    ...facebookMeta,
  ],
  header: { isLight: false },
  footer: true,
};

export default function MarvelVsInvision() {
  return (
    <Page {...meta}>
      <Header
        heading="Looking for an InVision alternative?"
        subHeading="We’re a simple, yet powerful design platform used by over 2
        million people to get important work done, faster."
        headerImage={assets.dashboard}
        mainColor="blue"
      />
      <Logos />
      <ImageBlock
        paragraphSize="m"
        title="Your Prototyping, User Testing and Dev Handoff workflow"
        copy="We’re focused on providing the most important, time-saving tools in your workflow in one place. Get everything you need to go from an idea to shipping awesome products in one place. "
        headingMaxWidth={435}
        paragraphMaxWidth={435}
        imageAsset={assets.prototypes}
      />
      <ImageBlock
        paragraphSize="m"
        title="Create realistic prototypes without code"
        copy={
          <span>
            Transform designs into prototypes with interactions such as{' '}
            <MarvelLink
              type="blue"
              url="https://help.marvelapp.com/hc/en-us/articles/360014699118-How-to-use-containers-carousels-and-scrolling-sidebars"
            >
              containers
            </MarvelLink>
            ,{' '}
            <MarvelLink
              type="blue"
              url="https://help.marvelapp.com/hc/en-us/articles/360003855577-How-to-embed-YouTube-Vimeo-or-Wistia-videos"
            >
              videos embeds
            </MarvelLink>
            , timers and more. Easily duplicate the same hotspot across multiple
            screens for quick work that’s simple for anyone to use.
          </span>
        }
        headingMaxWidth={435}
        paragraphMaxWidth={435}
        imageAsset={assets.imageEditor}
        isRightAligned
      />
      <ImageBlock
        paragraphSize="m"
        title="Validate and ship products faster with User Testing"
        copy="Create user tests that capture video and voice feedback so you can see reactions and listen to your users as they interact with your prototype. Access analytics that provide actionable insights into where your users had issues; eliminating guesswork so you can surface designs that work better."
        headingMaxWidth={435}
        paragraphMaxWidth={435}
        imageAsset={assets.usertesting}
      />
      <ImageBlock
        paragraphSize="m"
        title="Organise your designs, prototypes and user tests into folders"
        copy="Struggling with endless lists of projects in your dashboard and keeping track of all the links you keep sending to your developers and stakeholders? Folders keep everything together in one place and can be shared in public or private in a few clicks."
        headingMaxWidth={435}
        paragraphMaxWidth={435}
        imageAsset={assets.organise}
        isRightAligned
      />
      <ImageBlock
        paragraphSize="m"
        title="Switching is easy with simplified change management"
        copy="We offer bespoke project migration support to ensure minimal stress
        and effort on your part as you move from InVision to Marvel. We can
        also offer a greater variety of flexible pricing options when you
        choose to switch, speak to one our product specialists today to find out more."
        headingMaxWidth={435}
        paragraphMaxWidth={430}
        imageAsset={assets.invisionAlternative}
      />
      <Security />
      <ImageBlock
        paragraphSize="m"
        title="Unlimited customisation with the Marvel API"
        copy="Marvel is the only prototype platform to offer an API, allowing you to customise your workflow. Our GraphQL API gives you the power to build high value, custom workflows, integrations and tools on top of the Marvel platform. We also have dozens of time-saving integrations included such as Sketch, JIRA and many more."
        headingMaxWidth={459}
        paragraphMaxWidth={459}
        imageAsset={assets.posterLogos}
      />
      <Experience
        headingText="A customer experience you can count on"
        config={invisionExperienceConfig}
      />
      <RequestDemo image={assets.dashboard} />
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/marvel-vs-invision/index.js